(function () {
  var DEFAULT_EVENT_NAME = 'theme:hero_banner_viewed';
  var PROMOTION_RULES = [
    {
      key: 'home-top-banner-1',
      eventName: 'theme:hero_banner_viewed',
      selector: '.new-slideshow-section',
      /** creative_slot：{页面名称}_Carousel_Banner_{序号}（与公告栏 Top_Banner 分开） */
      dynamicTopBannerSlot: true,
      creativeSlotSegment: 'Carousel_Banner',
      promotionTitleSelector: '.new-slideshow-title, .new-slideshow-title-mb',
      promotionButtonSelector:
        '.new-button.new-slideshow-button, a.new-slideshow-button, .new-slideshow-button-mb, a.shop-all-link',
      fallbackPromotionName: 'Diapering Comfort,Redefined',
      fallbackPromotionId: 'Explore Now'
    },
    {
      key: 'announcement',
      eventName: 'theme:announcement_viewed',
      selector: '.t4-section-announcement-bar, #shopify-section-announcement-bar .t4s-announcement-bar',
      /** creative_slot：{页面名称}_Top_Banner_{序号}（顶栏公告，与 Hero 轮播 Carousel_Banner 分开） */
      dynamicTopBannerSlot: true,
      creativeSlotSegment: 'Top_Banner',
      slotIndexSelector:
        '.t4-section-announcement-bar, #shopify-section-announcement-bar .t4s-announcement-bar',
      promotionTitleSelector: '.t4s-announcement-bar__item, .t4s-top-bar-text__item',
      promotionButtonSelector:
        '.t4s-announcement-bar__item a, .t4s-top-bar-text__item a, a.t4s-announcement-bar__link',
      fallbackPromotionName: '10% off every Auto Reneworder.',
      fallbackPromotionId: 'Explore Now'
    }
  ];

  function canPublish() {
    return !!(
      window.Shopify &&
      Shopify.analytics &&
      typeof Shopify.analytics.publish === 'function'
    );
  }

  function normalizeValue(value) {
    if (value == null) return null;
    var str = String(value).replace(/\s+/g, ' ').trim();
    return str || null;
  }

  function normalizePromotionName(value) {
    var text = normalizeValue(value);
    if (!text) return null;
    return text.replace(/\s*,\s*/g, ',').replace(/\.$/, '');
  }

  function readText(root, selector) {
    if (!root || !selector || !root.querySelector) return null;
    var el = root.querySelector(selector);
    return normalizeValue(el && el.textContent);
  }

  /**
   * promotion_id：优先取 a 标签内文案（自身为 a 或子级第一个 a），再整节点 text / aria / data-gtm-cta
   */
  function readCtaLabelFromElement(el) {
    if (!el) return null;
    var tag = el.tagName ? String(el.tagName).toLowerCase() : '';
    var link = tag === 'a' ? el : el.querySelector && el.querySelector('a');
    if (link) {
      var linkText = normalizeValue(link.textContent);
      if (linkText) return linkText;
      var linkAria = normalizeValue(link.getAttribute && link.getAttribute('aria-label'));
      if (linkAria) return linkAria;
      var linkData = normalizeValue(link.getAttribute && link.getAttribute('data-gtm-cta'));
      if (linkData) return linkData;
    }
    var t = normalizeValue(el.textContent);
    if (t) return t;
    var aria = normalizeValue(el.getAttribute && el.getAttribute('aria-label'));
    if (aria) return aria;
    var dataCta = normalizeValue(el.getAttribute && el.getAttribute('data-gtm-cta'));
    if (dataCta) return dataCta;
    return null;
  }

  /**
   * promotion_id：遍历逗号分隔的多组选择器，取首个非空（优先各节点内 a 标签文本）
   */
  function readFirstMatchingPromotionCta(root, selectorCsv) {
    if (!root || !selectorCsv || !root.querySelectorAll) return null;
    var groups = String(selectorCsv)
      .split(',')
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);
    for (var g = 0; g < groups.length; g++) {
      var nodes = root.querySelectorAll(groups[g]);
      for (var i = 0; i < nodes.length; i++) {
        var label = readCtaLabelFromElement(nodes[i]);
        if (label) return label;
      }
    }
    return null;
  }

  /**
   * creative_slot 页面名称段（与 body[data-name] 无关）：Search / Collections / BlogDetails / Cart / Products / Home / Mom2026 / Other
   * 判定顺序：搜索 → 购物车 → 商品详情 → 集合/列表集合 → 博客/文章 → Campaign 落地页 → 首页 → 其他
   */
  function getPromotionCreativeSlotPageName() {
    var body = document.body;
    var bodyCls = body && body.className ? String(body.className) : '';
    var path = '';
    try {
      path = String(window.location.pathname || '').toLowerCase();
    } catch (_) {}

    var dataTpl = '';
    try {
      if (body && body.getAttribute) {
        dataTpl = String(body.getAttribute('data-template') || '').trim().toLowerCase();
      }
    } catch (_) {}

    if (bodyCls.indexOf('template-search') > -1 || /\/search$/i.test(path) || path.indexOf('/search?') > -1) {
      return 'Search';
    }
    if (bodyCls.indexOf('template-cart') > -1 || path === '/cart' || /\/cart$/i.test(path)) {
      return 'Cart';
    }
    if (bodyCls.indexOf('template-product') > -1 || path.indexOf('/products/') > -1) {
      return 'Products';
    }
    if (
      bodyCls.indexOf('template-collection') > -1 ||
      bodyCls.indexOf('template-list-collections') > -1 ||
      path.indexOf('/collections/') > -1
    ) {
      return 'Collections';
    }
    if (
      bodyCls.indexOf('template-blog') > -1 ||
      bodyCls.indexOf('template-article') > -1 ||
      path.indexOf('/blogs/') > -1
    ) {
      return 'BlogDetails';
    }
    if (
      dataTpl === 'mom2026' ||
      dataTpl === 'campaign' ||
      dataTpl === 'campagin' ||
      dataTpl === 'compagin' ||
      bodyCls.indexOf('template-page-mom2026') > -1 ||
      bodyCls.indexOf('template-page-campaign') > -1 ||
      bodyCls.indexOf('template-page-campagin') > -1 ||
      bodyCls.indexOf('template-page-compagin') > -1
    ) {
      return 'Mom2026';
    }
    if (bodyCls.indexOf('template-index') > -1 || path === '/' || path === '') {
      return 'Home';
    }
    return 'Other';
  }

  /**
   * 同一页多个同类推广容器时按文档顺序 1、2、3…
   * @param {string} [selectorCsv] 默认 .new-slideshow-section（Hero）；公告栏传入 rule.slotIndexSelector
   */
  function getPromotionSlotIndex(root, selectorCsv) {
    if (!root || !document.querySelectorAll) return 1;
    var sel = selectorCsv && String(selectorCsv).trim() ? String(selectorCsv).trim() : '.new-slideshow-section';
    var all = document.querySelectorAll(sel);
    for (var i = 0; i < all.length; i++) {
      if (all[i] === root) return i + 1;
    }
    return 1;
  }

  function logGTM(level, tag) {
    var rest = Array.prototype.slice.call(arguments, 2);

    function stripGtmUniqueEventId(value) {
      if (value == null) return value;
      if (Array.isArray(value)) return value.map(stripGtmUniqueEventId);
      if (typeof value === 'object') {
        var out = {};
        for (var k in value) {
          if (!Object.prototype.hasOwnProperty.call(value, k)) continue;
          if (k === 'gtm.uniqueEventId') continue;
          out[k] = stripGtmUniqueEventId(value[k]);
        }
        return out;
      }
      return value;
    }

    try {
      var prefix = '[GTM]' + (tag ? '[' + tag + ']' : '');
      var fn = level === 'warn' ? console.warn : console.log;
      var safeRest = rest.map(function (v) {
        return v && typeof v === 'object' ? stripGtmUniqueEventId(v) : v;
      });
      if (fn && fn.apply) {
        fn.apply(console, [prefix].concat(safeRest));
      }
    } catch (_) {}
  }

  function buildPayload(root, rule) {
    var creativeSlot = rule.creative_slot;
    if (rule && rule.dynamicTopBannerSlot) {
      var seg =
        rule.creativeSlotSegment && String(rule.creativeSlotSegment).trim()
          ? String(rule.creativeSlotSegment).trim()
          : 'Carousel_Banner';
      creativeSlot =
        getPromotionCreativeSlotPageName() + '_' + seg + '_' + String(getPromotionSlotIndex(root, rule.slotIndexSelector));
    }

    var promotionId =
      readFirstMatchingPromotionCta(root, rule.promotionButtonSelector) ||
      normalizeValue(rule.fallbackPromotionId) ||
      null;
    return {
      creative_slot: creativeSlot,
      promotion_id: promotionId,
      promotion_name:
        normalizePromotionName(readText(root, rule.promotionTitleSelector)) ||
        rule.fallbackPromotionName ||
        null,
      items: []
    };
  }

  function publishImpression(root, rule) {
    var eventName = String((rule && rule.eventName) || DEFAULT_EVENT_NAME);
    if (!canPublish()) {
      logGTM('warn', 'customPixel', 'Shopify.analytics.publish unavailable', eventName);
      return;
    }

    var payload = buildPayload(root, rule);
    var dedupeKey = [
      payload.creative_slot || '',
      payload.promotion_id || '',
      payload.promotion_name || ''
    ].join('|');
    window.__customGaViewedPromotions = window.__customGaViewedPromotions || {};
    if (window.__customGaViewedPromotions[dedupeKey]) return;
    window.__customGaViewedPromotions[dedupeKey] = 1;

    logGTM('log', 'customPixel', 'publish', eventName, payload);
    Shopify.analytics.publish(eventName, payload);
  }

  function setupObserver(root, rule) {
    if (!root || root.__customGaHeroObserved) return;
    root.__customGaHeroObserved = true;

    var observer = new IntersectionObserver(function (entries, obs) {
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        if (!entry || !entry.isIntersecting || entry.intersectionRatio <= 0) continue;
        publishImpression(entry.target, rule);
        obs.unobserve(entry.target);
      }
    }, {
      root: null,
      threshold: [0.25]
    });

    observer.observe(root);
  }

  function init(context) {
    if (!('IntersectionObserver' in window)) return;
    if (!canPublish()) return false;

    var scope = context || document;
    for (var i = 0; i < PROMOTION_RULES.length; i++) {
      var rule = PROMOTION_RULES[i];
      var roots = scope.querySelectorAll(rule.selector);
      for (var j = 0; j < roots.length; j++) {
        setupObserver(roots[j], rule);
      }
    }
    return true;
  }

  function initWhenReady(context, retryCount) {
    var triesLeft = typeof retryCount === 'number' ? retryCount : 40;
    if (init(context)) return;
    if (triesLeft <= 0) {
      logGTM('warn', 'customPixel', 'Shopify.analytics.publish still unavailable after retries', DEFAULT_EVENT_NAME);
      return;
    }
    window.setTimeout(function () {
      initWhenReady(context, triesLeft - 1);
    }, 250);
  }

  // ─────────────────────────────────────────────
  // New Quiz (new-quiz.liquid) — GTM dataLayer + optional analytics.publish
  // event_category / 文案：DOM + ga-pixel.js 与全站一致的命名（getGTMCampaginProductCardAtcCategory）
  // Events: Form_impression, Form_field_selection, Form_submisssion（规格拼写）
  // ─────────────────────────────────────────────

  function normalizeQuizText(value) {
    if (value == null) return '';
    return String(value).replace(/\s+/g, ' ').replace(/\u00a0/g, ' ').trim();
  }

  function pushQuizDataLayer(eventName, payload) {
    var name = String(eventName || '').trim();
    if (!name) return;
    window.dataLayer = window.dataLayer || [];
    var layer = Object.assign({}, payload || {}, {
      event: name,
      name: name
    });
    // 不向上报对象写入 GTM 内部 id；若曾从其它 dataLayer 对象合并误带入则去掉
    try {
      delete layer['gtm.uniqueEventId'];
    } catch (_) {}
    window.dataLayer.push(layer);
    logGTM('log', 'quizGtm', name, layer);
    if (canPublish()) {
      try {
        var pubName = 'theme:quiz_' + name.replace(/[^a-z0-9_]/gi, '_').toLowerCase();
        Shopify.analytics.publish(pubName, layer);
      } catch (err) {
        logGTM('warn', 'quizGtm', 'analytics.publish failed', err);
      }
    }
  }

  function getQuizModuleRoot(container) {
    return container && container.closest
      ? container.closest('.common-section-container, .shopify-section, section')
      : null;
  }

  /** 无 ga-pixel 时：与 getGTMPageSuffixPrefix 一致，自定义 Page 模板读 body[data-template] */
  function getQuizPageTemplatePrefixFallback() {
    if (typeof getGTMPageSuffixPrefix === 'function') return getGTMPageSuffixPrefix();
    var bodyCls = document.body && document.body.className ? String(document.body.className) : '';
    if (bodyCls.indexOf('template-page') === -1) return '';
    var dt = '';
    try {
      if (document.body && document.body.getAttribute) {
        dt = String(document.body.getAttribute('data-template') || '').trim();
      }
    } catch (_) {}
    if (!dt) return '';
    var low = dt.toLowerCase();
    if (low === 'campagin' || low === 'campaign') return 'Campaign_';
    return dt
      .replace(/-/g, ' ')
      .replace(/\b\w/g, function (ch) {
        return ch.toUpperCase();
      })
      .replace(/\s+/g, '') + '_';
  }

  /** 与 ga-pixel.js 一致：集合页优先 breadcrumb 的 data-gtm-list-name-suffix（与 view_item_list 对齐）；无 ga-pixel 时再 data-gtm-menu-l1/l2 */
  function getQuizEventCategoryFallback(container) {
    var moduleRoot = getQuizModuleRoot(container);
    var bodyCls = document.body && document.body.className ? String(document.body.className) : '';
    var path = String(window.location.pathname || '');

    var pageTplPrefix = getQuizPageTemplatePrefixFallback();
    if (pageTplPrefix) {
      var menuSuffix0 = '';
      if (typeof getGtmCollectionMenuCategorySuffix === 'function') {
        menuSuffix0 = getGtmCollectionMenuCategorySuffix();
      } else {
        var mEl0 = document.getElementById('gtm-collection-menu-context');
        if (mEl0 && mEl0.getAttribute) {
          var a0 = String(mEl0.getAttribute('data-gtm-menu-l1') || '').replace(/\s+/g, ' ').trim();
          var b0 = String(mEl0.getAttribute('data-gtm-menu-l2') || '').replace(/\s+/g, ' ').trim();
          if (a0) menuSuffix0 = b0 ? a0 + '_' + b0 : a0;
        }
      }
      if (menuSuffix0) return pageTplPrefix + menuSuffix0;
      var titleEl0 =
        moduleRoot && moduleRoot.querySelector
          ? moduleRoot.querySelector(
              '.common-header .common-title, .common-header h2, .common-header h3, .section-title'
            )
          : null;
      var t0 = titleEl0 && titleEl0.textContent ? normalizeQuizText(titleEl0.textContent) : 'Products';
      return pageTplPrefix + t0;
    }

    var prefix = 'Collections_';
    if (bodyCls.indexOf('template-index') > -1 || path === '/') prefix = 'Home_';
    else if (bodyCls.indexOf('template-product') > -1 || path.indexOf('/products/') === 0) {
      prefix = 'Goods_';
    }

    if (
      prefix === 'Collections_' &&
      bodyCls.indexOf('template-collection') > -1 &&
      path.indexOf('/collections/') > -1
    ) {
      var bcEl = document.getElementById('gtm-collection-menu-context');
      if (bcEl && bcEl.getAttribute) {
        var bcSuf = String(bcEl.getAttribute('data-gtm-list-name-suffix') || '')
          .replace(/\s+/g, ' ')
          .trim();
        if (bcSuf) return prefix + bcSuf;
      }
    }

    var menuSuffix = '';
    if (typeof getGtmCollectionMenuCategorySuffix === 'function') {
      menuSuffix = getGtmCollectionMenuCategorySuffix();
    } else {
      var mEl = document.getElementById('gtm-collection-menu-context');
      if (mEl && mEl.getAttribute) {
        var a = String(mEl.getAttribute('data-gtm-menu-l1') || '').replace(/\s+/g, ' ').trim();
        var b = String(mEl.getAttribute('data-gtm-menu-l2') || '').replace(/\s+/g, ' ').trim();
        if (a) menuSuffix = b ? a + '_' + b : a;
      }
    }
    if (menuSuffix) return prefix + menuSuffix;

    var titleEl = moduleRoot && moduleRoot.querySelector
      ? moduleRoot.querySelector('.common-header .common-title, .common-header h2, .common-header h3, .section-title')
      : null;
    var t = titleEl && titleEl.textContent ? normalizeQuizText(titleEl.textContent) : 'Products';
    return prefix + t;
  }

  function getQuizEventCategory(container) {
    var bodyCls = document.body && document.body.className ? String(document.body.className) : '';
    var path = String(window.location.pathname || '');
    /** 集合页：与 ga-pixel getGTMListName / breadcrumb.liquid 的 data-gtm-list-name-suffix 一致（非 L1_L2 菜单名） */
    if (bodyCls.indexOf('template-collection') > -1 && path.indexOf('/collections/') > -1) {
      var ctx = document.getElementById('gtm-collection-menu-context');
      if (ctx && ctx.getAttribute) {
        var suffix = String(ctx.getAttribute('data-gtm-list-name-suffix') || '')
          .replace(/\s+/g, ' ')
          .trim();
        if (suffix) return normalizeQuizText('Collections_' + suffix);
      }
    }

    var moduleRoot = getQuizModuleRoot(container);
    if (typeof getGTMCampaginProductCardAtcCategory === 'function') {
      var cat = getGTMCampaginProductCardAtcCategory(moduleRoot);
      if (cat) return normalizeQuizText(cat);
    }
    return getQuizEventCategoryFallback(container);
  }

  /** Form_impression 的 event_label：模块标题（common-header 内 section-title / common-title） */
  function getQuizImpressionEventLabel(container) {
    var root = getQuizModuleRoot(container);
    if (!root || !root.querySelector) return '';
    var title = root.querySelector(
      '.common-header .section-title, .common-header .common-title, .common-header h2.section-title'
    );
    if (title && title.textContent) return normalizeQuizText(title.textContent);
    return '';
  }

  function getQuizContainerFrom(node) {
    if (!node || !node.closest) return null;
    // 首页等通过 fetch 写入 section.innerHTML 时，外层 shopify-section 上的 new-quiz-container 会被剥掉，
    // 仅保留内部的 .new-quiz-inner-container，因此不能只依赖 .new-quiz-container。
    return (
      node.closest('.new-quiz-container .new-quiz-inner-container') ||
      node.closest('.collection-quiz-card-wrapper .new-quiz-inner-container') ||
      node.closest('.new-quiz-inner-container')
    );
  }

  /** 题干预想：与页面对齐，去掉末尾冒号，避免与选项拼接歧义 */
  function getQuizQuestionStemText(titleEl) {
    if (!titleEl) return '';
    var raw =
      titleEl.innerText != null && String(titleEl.innerText).trim() !== ''
        ? titleEl.innerText
        : titleEl.textContent;
    return normalizeQuizText(String(raw || '').replace(/[:：]\s*$/g, ''));
  }

  function quizFieldEventLabel(questionTitle, optionLabel) {
    var t = normalizeQuizText(questionTitle);
    var o = normalizeQuizText(optionLabel);
    if (!t || !o) return '';
    if (o === 'Please select') return '';
    return t + '_' + o;
  }

  /**
   * 第 n 个下拉题（0=第一个 select，1=第二个）：{题干}_{当前选中项}，与 Form_field_selection 规则一致
   * 按 .new-quiz-question-block 在问卷内的出现顺序，不依赖 data-question-position 编号
   */
  function quizPairForNthSelect(container, nthZeroBased) {
    var n = Number(nthZeroBased);
    if (!container || !container.querySelectorAll || n !== n || n < 0) return '';
    var blocks = container.querySelectorAll('.new-quiz-question-block');
    if (!blocks || n >= blocks.length) return '';
    var block = blocks[n];
    if (!block) return '';
    var titleEl = block.querySelector('.new-quiz-question-title');
    var ph = block.querySelector('.common-custom-select .common-custom-select__placeholder');
    if (!titleEl || !ph) return '';
    return quizFieldEventLabel(getQuizQuestionStemText(titleEl), ph.textContent);
  }

  function bindQuizImpressionObservers(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll
      ? scope.querySelectorAll('.new-quiz-inner-container')
      : [];
    for (var i = 0; i < nodes.length; i++) {
      (function (container) {
        if (!container || container.__quizGtmImpBound) return;
        container.__quizGtmImpBound = true;

        function fireOnce() {
          if (container.__quizGtmImpFired) return;
          var cat = getQuizEventCategory(container);
          var label = getQuizImpressionEventLabel(container);
          if (!cat || !label) return;
          container.__quizGtmImpFired = true;
          pushQuizDataLayer('Form_impression', {
            event_category: cat,
            event_label: label
          });
        }

        if (!('IntersectionObserver' in window)) {
          fireOnce();
          return;
        }
        var observer = new IntersectionObserver(function (entries, obs) {
          for (var j = 0; j < entries.length; j++) {
            var entry = entries[j];
            if (!entry || !entry.isIntersecting || entry.intersectionRatio <= 0) continue;
            fireOnce();
            obs.unobserve(entry.target);
          }
        }, {
          root: null,
          threshold: [0.25]
        });
        observer.observe(container);
      })(nodes[i]);
    }
  }

  function initNewQuizGtmTracking() {
    if (document.documentElement.dataset.customGaQuizGtmClickBound === '1') return;
    document.documentElement.dataset.customGaQuizGtmClickBound = '1';

    document.addEventListener(
      'click',
      function (e) {
        var target = e.target;
        if (!target || !target.closest) return;

        var optionEl = target.closest('.common-custom-select__option');
        if (optionEl) {
          var container = getQuizContainerFrom(optionEl);
          if (!container) return;
          var block = optionEl.closest('.new-quiz-question-block');
          if (!block) return;
          var cat = getQuizEventCategory(container);
          if (!cat) return;
          var selectEl = optionEl.closest('.common-custom-select');
          // 必须在主题内联脚本更新 placeholder 之后再读，否则 event_label 会与规范 "{题干}_{选项}" 不一致
          window.setTimeout(function () {
            var titleEl = block.querySelector('.new-quiz-question-title');
            var qStem = getQuizQuestionStemText(titleEl);
            var ph =
              selectEl && selectEl.querySelector
                ? selectEl.querySelector('.common-custom-select__placeholder')
                : null;
            var oLabel = '';
            if (ph && ph.textContent) {
              oLabel = normalizeQuizText(ph.textContent);
            }
            if (!oLabel || oLabel === 'Please select') {
              oLabel = normalizeQuizText(
                optionEl.getAttribute('data-label') || optionEl.textContent || ''
              );
            }
            var evLabel = quizFieldEventLabel(qStem, oLabel);
            if (!qStem || !evLabel) return;
            pushQuizDataLayer('Form_field_selection', {
              event_category: cat,
              event_label: evLabel
            });
          }, 0);
          return;
        }

        var submitBtn = target.closest('.new-quiz-submit-btn');
        if (submitBtn) {
          var c2 = getQuizContainerFrom(submitBtn);
          if (!c2) return;
          var cat2 = getQuizEventCategory(c2);
          var submitLabel = normalizeQuizText(submitBtn.textContent || '');
          var babyAbility = quizPairForNthSelect(c2, 0);
          var babyFeature = quizPairForNthSelect(c2, 1);
          if (!cat2 || !submitLabel) return;
          pushQuizDataLayer('Form_submisssion', {
            event_category: cat2,
            event_label: submitLabel,
            baby_ability_label: babyAbility,
            baby_feature_label: babyFeature
          });
        }
      },
      true
    );
  }

  // ─────────────────────────────────────────────
  // 搜索无结果页：dataLayer `searched`（仅 results_count===0；Custom Pixel 同事件名）
  // 与 ga-pixel.js 去重键共用，避免双发
  // ─────────────────────────────────────────────

  function getSearchQueryFromUrlForNoResult() {
    try {
      var params = new URLSearchParams(String(window.location.search || ''));
      return String(params.get('q') || '').trim();
    } catch (e) {
      return '';
    }
  }

  function parseSearchTermFromHeading() {
    var h1 = document.querySelector('h1');
    if (!h1 || !h1.textContent) return '';
    var raw = String(h1.textContent).replace(/\s+/g, ' ').trim();
    var m = raw.match(/for:\s*(.+)$/i);
    if (!m || !m[1]) return '';
    return String(m[1])
      .replace(/^[\u201c\u201d\u2018\u2019"'「『«]+/, '')
      .replace(/[\u201c\u201d\u2018\u2019"'」』»]+$/, '')
      .trim();
  }

  /**
   * 仅「全站搜索确实 0 条结果」为 true（避免 Articles/Pages 空 tab 误判）。
   * 优先读主题输出的 data-gtm-search-results-count（new-main-search / main-search）。
   */
  function findSearchNoResultsMarkerEl() {
    var meta = document.querySelector('[data-gtm-search-results-count]');
    if (meta && meta.getAttribute) {
      var raw = String(meta.getAttribute('data-gtm-search-results-count') || '').trim();
      var n = parseInt(raw, 10);
      if (!isNaN(n)) {
        if (n > 0) return false;
        if (n === 0) return true;
      }
    }
    if (document.querySelector('.new-search-no-results')) return true;
    if (document.querySelector('.t4s-main-collection-search .t4s-coll-empty .t4s-no-result-product')) return true;
    if (document.querySelector('.t4s-main-collection-search .t4s-no-result-product')) return true;
    return false;
  }

  /** 支持 /search、/en/search、/zh-cn/search 等（不能用 pathname.indexOf('/search')===0） */
  function isStorefrontSearchPath(pathname) {
    var p = String(pathname || '');
    if (p === '/search') return true;
    return /\/search$/i.test(p);
  }

  function pushSearchNoResultsDataLayerOnce() {
    var path = String(window.location.pathname || '');
    if (!isStorefrontSearchPath(path)) return;
    if (!findSearchNoResultsMarkerEl()) return;

    var term = getSearchQueryFromUrlForNoResult();
    if (!term) term = parseSearchTermFromHeading();
    if (!term) return;

    // dataLayer 与 publish 分开去重：首次 DOMContentLoaded 时 analytics.publish 常尚未就绪，否则重试会被整块 dedupe 挡掉
    window.__gtmSearchNoResultState = window.__gtmSearchNoResultState || {};
    var st = window.__gtmSearchNoResultState[term];
    if (!st) st = window.__gtmSearchNoResultState[term] = { dl: false, pub: false };

    var payload = {
      event: 'searched',
      name: 'searched',
      event_category: 'Search Page',
      search_term: term,
      event_label: 'No Results Found'
    };
    try {
      delete payload['gtm.uniqueEventId'];
    } catch (_) {}

    if (!st.dl) {
      st.dl = true;
      window.dataLayer = window.dataLayer || [];
      logGTM('log', 'customPixel', 'searched', payload);
      window.dataLayer.push(payload);
    }

    if (canPublish() && !st.pub) {
      try {
        Shopify.analytics.publish('theme:search_no_results', payload);
        st.pub = true;
      } catch (pubErr) {
        logGTM('warn', 'customPixel', 'search_no_results publish failed', pubErr);
      }
    }
  }

  function initSearchPageNoResultsTracking() {
    pushSearchNoResultsDataLayerOnce();
    window.setTimeout(pushSearchNoResultsDataLayerOnce, 400);
    window.setTimeout(pushSearchNoResultsDataLayerOnce, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initWhenReady(document);
      bindQuizImpressionObservers(document);
      initNewQuizGtmTracking();
      initSearchPageNoResultsTracking();
    });
  } else {
    initWhenReady(document);
    bindQuizImpressionObservers(document);
    initNewQuizGtmTracking();
    initSearchPageNoResultsTracking();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    initWhenReady(event.target);
    bindQuizImpressionObservers(event.target);
    initSearchPageNoResultsTracking();
  });

  document.addEventListener('bc:collection-quiz-injected', function (event) {
    var r = event.detail && event.detail.root;
    bindQuizImpressionObservers(r || document);
  });

  /** fetch 注入 .collection-quiz-card-wrapper 等内容后调用，补绑 Form_impression 观察器 */
  window.__customGaPixelRebindQuiz = function (root) {
    try {
      bindQuizImpressionObservers(root || document);
    } catch (err) {
      logGTM('warn', 'quizGtm', '__customGaPixelRebindQuiz failed', err);
    }
  };

  // ─────────────────────────────────────────────
  // Ajax 加车成功（/cart/add*.js）→ 页面 dataLayer：event add_to_carted（name 固定 add_to_cart）+ Auto-Renew（selling_plan_allocation）
  // 与 assets/ga-pixel.js 中 event_label 规则一致。Customer Events / 自定义像素见 shopify-custom-pixel-gtm.js 的 product_added_to_cart
  // https://shopify.dev/docs/api/ajax/reference/cart#post-locale-cart-add-js
  // ─────────────────────────────────────────────

  function getStorefrontCurrencyCode() {
    try {
      if (window.T4Sconfigs && window.T4Sconfigs.cartCurrency) return String(window.T4Sconfigs.cartCurrency);
      if (window.T4Sconfigs && window.T4Sconfigs.shopCurency) return String(window.T4Sconfigs.shopCurency);
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) return String(window.Shopify.currency.active);
    } catch (_) {}
    return '';
  }

  function normalizeCartAddLines(data) {
    if (!data || typeof data !== 'object') return [];
    if (Array.isArray(data)) return data.filter(Boolean);
    if (Array.isArray(data.items)) return data.items.filter(Boolean);
    if (data.description != null && data.message != null) return [];
    if (data.variant_id != null || data.product_id != null || data.id != null) return [data];
    return [];
  }

  function sellingPlanNameFromLine(line) {
    if (!line) return '';
    var spa = line.selling_plan_allocation || line.sellingPlanAllocation;
    var sp = spa && (spa.selling_plan || spa.sellingPlan);
    var n = sp && (sp.name || sp.title);
    return String(n || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function buildAtcEventLabelFromPlan(planName) {
    var p = String(planName || '').trim();
    if (!p) return 'One-time';
    if (/^Auto_Renew_/i.test(p)) return p;
    return 'Auto_Renew_' + p;
  }

  function lineFinalValueMoney(line) {
    var q = parseInt(line && line.quantity, 10);
    if (isNaN(q) || q < 1) q = 1;
    var cents = line && line.final_line_price != null ? Number(line.final_line_price) : NaN;
    if (!isNaN(cents)) return Math.round(cents) / 100;
    cents = line && line.line_price != null ? Number(line.line_price) : NaN;
    if (!isNaN(cents)) return Math.round(cents) / 100;
    var unit = line && line.price != null ? Number(line.price) : 0;
    return Math.round(unit * q) / 100;
  }

  function lineUnitPriceMoney(line) {
    var q = parseInt(line && line.quantity, 10);
    if (isNaN(q) || q < 1) q = 1;
    var total = lineFinalValueMoney(line);
    return Math.round((total / q) * 100) / 100;
  }

  function buildGa4ItemsFromCartLines(lines) {
    return lines.map(function (line) {
      var pid = line.product_id != null ? String(line.product_id) : '';
      var vid = line.variant_id != null ? String(line.variant_id) : String(line.id || '');
      return {
        item_id: pid || vid,
        item_name: String(line.product_title || line.title || '').trim() || 'Unknown product',
        item_brand: String(line.vendor || '').trim() || undefined,
        item_category: String(line.product_type || '').trim() || undefined,
        item_variant: String(line.variant_title || '').trim() || undefined,
        custom_sku_id: vid || undefined,
        price: lineUnitPriceMoney(line),
        quantity: parseInt(line.quantity, 10) || 1
      };
    });
  }

  function pushAddToCartFromCartAddResponse(data) {
    var lines = normalizeCartAddLines(data);
    if (!lines.length) return;

    var labelPlan = '';
    for (var i = 0; i < lines.length; i++) {
      var pn = sellingPlanNameFromLine(lines[i]);
      if (pn) {
        labelPlan = pn;
        break;
      }
    }
    var event_label = buildAtcEventLabelFromPlan(labelPlan);

    var currency = getStorefrontCurrencyCode();
    var value = lines.reduce(function (sum, line) {
      return sum + lineFinalValueMoney(line);
    }, 0);
    value = Math.round(value * 100) / 100;

    var sigParts = lines.map(function (l) {
      return [l.variant_id || l.id, l.final_line_price, l.quantity, sellingPlanNameFromLine(l)].join(':');
    });
    var bucket = String(Math.floor(Date.now() / 700));
    var dedupe = sigParts.join('|') + '|' + bucket;
    window.__customGaAtcDedupe = window.__customGaAtcDedupe || {};
    if (window.__customGaAtcDedupe[dedupe]) return;
    window.__customGaAtcDedupe[dedupe] = 1;

    var items = buildGa4ItemsFromCartLines(lines);
    var payload = {
      event: 'add_to_carted',
      name: 'add_to_cart',
      event_label: event_label,
      currency: currency,
      value: value,
      ecommerce: {
        currency: currency,
        value: value,
        items: items
      }
    };
    try {
      delete payload['gtm.uniqueEventId'];
    } catch (_) {}
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(payload);
    logGTM('log', 'atc', 'add_to_carted', payload);
  }

  function installCartAddFetchHook() {
    if (window.__customGaCartAddFetchHook) return;
    window.__customGaCartAddFetchHook = true;
    var orig = window.fetch;
    if (typeof orig !== 'function') return;
    window.fetch = function (input, init) {
      var url = '';
      if (typeof input === 'string') url = input;
      else if (typeof Request !== 'undefined' && input instanceof Request) url = String(input.url || '');
      else if (input && input.url) url = String(input.url);
      var isCartAdd = url.indexOf('/cart/add') !== -1 && /\.js(\?|$)/.test(url);
      var p = orig.apply(this, arguments);
      if (!isCartAdd || !p || typeof p.then !== 'function') return p;
      return p.then(function (res) {
        try {
          if (!res || !res.ok || !res.clone) return res;
          res
            .clone()
            .json()
            .then(function (json) {
              try {
                pushAddToCartFromCartAddResponse(json);
              } catch (e) {
                logGTM('warn', 'atc', 'pushAddToCartFromCartAddResponse', e);
              }
            })
            .catch(function () {});
        } catch (e) {}
        return res;
      });
    };
  }

  installCartAddFetchHook();
})();
 